import { useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { AuthLayout } from "@/components/app/AuthLayout";
import { Field } from "@/components/app/kit";
import { api, formatApiError } from "@/lib/api";

export const PasswordPair = ({ f, setF, prefix }) => (
  <>
    <Field label="Nouveau mot de passe" required hint="10 caractères minimum, avec au moins une lettre et un chiffre">
      <Input type="password" autoComplete="new-password" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} required data-testid={`${prefix}-password-input`} />
    </Field>
    <Field label="Confirmer le mot de passe" required>
      <Input type="password" autoComplete="new-password" value={f.confirm} onChange={(e) => setF({ ...f, confirm: e.target.value })} required data-testid={`${prefix}-confirm-input`} />
    </Field>
  </>
);

export default function ResetPassword() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [f, setF] = useState({ password: "", confirm: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (f.password !== f.confirm) return setError("Les mots de passe ne correspondent pas");
    setBusy(true);
    setError("");
    try {
      await api.post("/auth/reset-password", { token, password: f.password });
      toast.success("Mot de passe réinitialisé. Vous pouvez vous connecter.");
      navigate("/connexion");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <AuthLayout title="Nouveau mot de passe" subtitle="Choisissez un mot de passe robuste. Toutes vos sessions seront fermées.">
      <form onSubmit={submit} className="space-y-5">
        <PasswordPair f={f} setF={setF} prefix="reset" />
        {error && <p className="text-sm text-red-600" data-testid="reset-error">{error}</p>}
        <Button type="submit" className="w-full h-11" disabled={busy} data-testid="reset-submit-button">
          {busy && <Loader2 className="h-4 w-4 animate-spin mr-2" />}Réinitialiser
        </Button>
      </form>
      <Link to="/connexion" className="block mt-6 text-sm text-sky-700 hover:underline">Retour à la connexion</Link>
    </AuthLayout>
  );
}
